import { NavCubePlugin } from "@xeokit/xeokit-sdk";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { XktContext } from "../../Context/XktContext/XktContextProvider";

import clsx from "clsx";
import { setProjection } from "../../Context/ViewerContext/Reducer";
import { ViewerContext } from "../../Context/ViewerContext/ViewerContextProvider";
import { useTheme } from "../theme-provider";
import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuLabel,
    ContextMenuRadioGroup,
    ContextMenuRadioItem,
    ContextMenuSeparator,
    ContextMenuTrigger,
} from "../ui/context-menu";

const Navcube = ({ useSpacer = false }: { useSpacer: boolean }) => {
    const { state } = useContext(XktContext);
    const { state: viewerState, dispatch } = useContext(ViewerContext);
    const [navCube, setNavCube] = useState<NavCubePlugin | null>(null);
    const { t } = useTranslation();
    const { theme } = useTheme();

    const resolveNavCube = () => {
        if (state.viewer) {
            // Destroy existing navCube if it exists
            if (navCube) {
                navCube.destroy();
                setNavCube(null);
            }

            let color = "rgba(255, 255, 255, 0.5)";
            let textColor = "black";
            let hoverColor = "rgba(0, 0, 0, 0.4)";

            let targetTheme = theme;
            if (theme === "system")
                targetTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

            if (targetTheme === "dark") {
                color = "#1e2939";
                textColor = "white";
                hoverColor = "rgba(1, 1, 1, 0.5)";
            }

            const newNavCube = new NavCubePlugin(state.viewer, {
                canvasId: "navCube",
                color,
                textColor,
                shadowVisible: false,
                hoverColor,
            });

            setNavCube(newNavCube);

            const navcubeTextureCanvas = Array.from(document.querySelectorAll("canvas")).filter((x) => x.id === "");

            if (navcubeTextureCanvas.length > 0) {
                navcubeTextureCanvas.forEach((canvas, index) => {
                    canvas.id = "navCubeTexture" + index;
                });
            }
        } else if (navCube) {
            navCube.destroy();
            setNavCube(null);
        }
    };

    // Update NavCube when viewer, language, or theme changes
    useEffect(() => {
        resolveNavCube();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.viewer, theme]);

    useEffect(() => {
        if (state.viewer == null) return;
        state.viewer.camera.projection = viewerState.projection;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewerState.projection]);

    return (
        <ContextMenu>
            <ContextMenuTrigger asChild>
                <canvas
                    id="navCube"
                    className={clsx(["absolute top-0 right-0 h-[200px] w-[200px] z-40", useSpacer && "mt-12"])}
                />
            </ContextMenuTrigger>
            <ContextMenuContent>
                <ContextMenuLabel>{t("cameraProjection")}</ContextMenuLabel>
                <ContextMenuSeparator />
                <ContextMenuRadioGroup value={viewerState.projection}>
                    <ContextMenuRadioItem value="perspective" onClick={() => dispatch(setProjection("perspective"))}>
                        {t("perspective")}
                    </ContextMenuRadioItem>
                    <ContextMenuRadioItem value="ortho" onClick={() => dispatch(setProjection("ortho"))}>
                        {t("orthographic")}
                    </ContextMenuRadioItem>
                </ContextMenuRadioGroup>
            </ContextMenuContent>
        </ContextMenu>
    );
};

export default Navcube;
